export const arknoteHRP = 'arknote'
export const defaultFee = 0
export const testDomains = ['dev.arkade.money', 'next.arkade.money', 'pages.dev', 'localhost']
export const devServer = 'http://localhost:7070'
export const testServer = 'https://bitcoin-beta-v8.arkade.sh'
export const mainServer = 'https://bitcoin-beta-v8.arkade.sh'
export const defaultPassword = 'noah'
export const minSatsToNudge = 10_000
export const maxPercentage = import.meta.env.VITE_MAX_PERCENTAGE ?? 10

export const defaultArkServer = () => {
  if (import.meta.env.VITE_ARK_SERVER) return import.meta.env.VITE_ARK_SERVER
  for (const domain of testDomains) {
    if (window.location.hostname.includes(domain)) {
      return window.location.hostname.includes('localhost') ? devServer : testServer
    }
  }
  return mainServer
}
